import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';
import { SnackbarProvider } from './context/SnackbarContext';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <ScrollTop>
        <SnackbarProvider>
          <RouterProvider router={router} />
        </SnackbarProvider>
      </ScrollTop>
    </ThemeCustomization>
  );
}
